// extracted by mini-css-extract-plugin
export default {"mn-official-inspiration":"index_mn-official-inspiration__PN2xo"};